module.exports = __webpack_public_path__ + "static/media/icon_dashboard.abe2584b.svg";